import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { useNavigate } from 'react-router-dom';

function FilesList() {
  const profileFilter = chooseProfileFilter();
  const navigate = useNavigate();

  const pathFrontEnd = '/gci/banking-histories/';
  const endpointBackend = config.endpoints.backend;

  const paths = {
    pathAdd: pathFrontEnd + 'add',
    pathEdit: pathFrontEnd + 'edit',
    pathView: pathFrontEnd + 'view',
    endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
    endpointGetAllBankAccounts: `${endpointBackend}gci/bank-accounts/getall`,
    endpointDelete: `${endpointBackend}gci/file-banking-histories/delete`,
    endpoint: `${endpointBackend}gci/file-banking-histories/getall`
  }

  const filters = {
    validateOnChange: true,
    showGoBackButton: false,
    showSubmitButton: false,
    handleSubmit: loadData,
    fields: [
      !profileFilter.gci_company_id ? {
        name: 'gci_company_id',
        type: 'select',
        label: 'Empresa',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllCompanies,
          label: 'name',
          value: 'id'
        },
        validations: {
          required: false
        },
        columnSize: 4,
      } : {},
      {
        name: 'gci_bank_account_id',
        type: 'select',
        label: 'Conta Bancária',
        options: [],
        optionsEndpoint: {
          endpoint: paths.endpointGetAllBankAccounts,
          label: 'full_name',
          value: 'id',
          params: {
            filter: {
              ...profileFilter
            }
          }
        },
        validations: {
          required: false
        },
        columnSize: 4
      },
      {
        name: 'filtro',
        type: 'submit',
        label: 'Pesquisar',
        columnSize: 1
      },
      {
        name: 'reset',
        type: 'reset',
        label: 'Limpar',
        columnSize: 2
      },
    ]
  }

  let list = {
    labelTitle: 'Lista de Importações de Extratos Bancários',
    labelTitleButtonAdd: 'Importar',
    fieldsShowOnDelete: ['company_name'],
    showPrintButtons: true,
    canAdd: false,
    canEdit: false,
    canView: false,
    formFilters: filters,
    filter: {
      ...profileFilter
    },
    columns: [
      {
        name: 'company_name',
        label: 'Empresa',
      },
      {
        name: 'bank_account_name',
        label: 'Conta Bancária',
      },
      {
        name: 'imported_period',
        label: 'Período',
        width: '20%'
      },
      {
        name: 'imported_begin',
        label: 'Início em',
      },
      {
        name: 'imported_finish',
        label: 'Finalizado em',
      },
      {
        name: 'formatted_status',
        label: 'Status',
      }
    ],
    buttonsListContainer: [
      {
        name: 'go_back_banking_histories',
        class: 'btn btn-secondary',
        label: 'Voltar',
        tooltipLabel: 'Histórico',
        callback: async () => {
          navigate(`/gci/banking-histories/competencies`)
        }
      }
    ],
  };

  list = { ...list, ...paths };

  return (
    <div>
      <CustomListContainer
        buttons={list.buttonsListContainer}
        canAdd={list.canAdd}
        pathAdd={list.pathAdd}
        labelTitle={list.labelTitle}
        labelTitleButtonAdd={list.labelTitleButtonAdd}
        content={<CustomList list={{ ...list, ...paths }} />}
      />
    </div>
  );
}
export default FilesList;
